import SmazzoStesa from "./SmazzoStesa";

export default function Stesa26() {
  return <SmazzoStesa deck="stesa26" />;
}
